import { render, staticRenderFns } from "./TSGFrischwasser.vue?vue&type=template&id=306e0582&"
import script from "./TSGFrischwasser.vue?vue&type=script&lang=ts&"
export * from "./TSGFrischwasser.vue?vue&type=script&lang=ts&"
import style0 from "./TSGFrischwasser.vue?vue&type=style&index=0&id=306e0582&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports